import { useSyncExternalStore } from 'react';

// Module-level store for the disabled-bypass-trap effect. Activation is one-way: once
// triggered it stays on until the page is refreshed, at which point this module state
// resets naturally. Kept as a standalone store so the trap stays fully decoupled from the
// app's global state.

let active = false;
const listeners = new Set<() => void>();

/**
 * Trigger the bypass-trap effect (idempotent) and notify subscribers.
 * @returns true only on the first activation, false if it was already on.
 */
export const activateBypassTrap = (): boolean => {
  if (active) return false;
  active = true;
  listeners.forEach(listener => listener());
  return true;
};

/** Current trap state — the external-store snapshot. */
export const isBypassTrapActive = (): boolean => active;

/** Subscribe to trap changes; returns an unsubscribe function. */
export const subscribeToBypassTrap = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** React binding: re-renders the caller when the trap activates. */
export const useBypassTrapActive = (): boolean =>
  useSyncExternalStore(subscribeToBypassTrap, isBypassTrapActive, () => false);
